export const generateFormPath = (value: string, path?: string) => {
  if (!path) return value;
  return `${path}.${value}`;
};
